"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgDownloadCloud = function SvgDownloadCloud(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 24a1 1 0 011 1v6.585l2.293-2.292a1 1 0 011.414 1.414l-4 4a1.006 1.006 0 01-.09.08l.09-.08a1.008 1.008 0 01-.688.293.99.99 0 01-.019 0h-.02c-.023 0-.046-.002-.069-.004L24 35a1.008 1.008 0 01-.618-.214 1.017 1.017 0 01-.09-.079l-4-4a1 1 0 011.415-1.414L23 31.585V25a1 1 0 011-1zm-1.98-8.953A9 9 0 0129.48 21H30a6 6 0 013.455 10.908 1 1 0 01-1.15-1.636A4 4 0 0030 23h-1.26a1 1 0 01-.969-.751 7 7 0 10-12.022 6.378 1 1 0 01-1.498 1.326 9 9 0 017.77-14.906z",
    id: "download-cloud_svg__a"
  }));
};

var _default = SvgDownloadCloud;
exports["default"] = _default;